const doc = [({"se":({"models":({"concerns":({"has_liquid_conditions":({})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;